var config = {
    store_hours: {
        date: false,
        technician: false,
        save: false,
        delete: false,
        status: ['store_hours'],
        btnLabel: 'Update',
    },
    available: {
        date: false,
        technician: true,
        save: true,
        delete: true,
        status: ['available', 'no_service'],
        btnLabel: 'Update',
    },
    no_service: {
        date: false,
        technician: false,
        save: true,
        delete: true,
        status: ['available', 'no_service'],
        btnLabel: 'Update',
    },
    no_service_holiday: {
        date: false,
        technician: false,
        save: false,
        delete: false,
        status: ['override_future'],
        btnLabel: 'Update',
    },
    available_new: {
        date: false,
        technician: true,
        save: true,
        delete: false,
        status: ['available_new', 'no_service_new', 'override'],
        btnLabel: 'Save Rotation',
    },
    no_service_new: {
        date: false,
        technician: false,
        save: true,
        delete: false,
        status: ['available_new', 'no_service_new'],
        btnLabel: 'Save Rotation',
    },
    override: {
        date: true,
        technician: true,
        save: true,
        delete: true,
        status: ['override'],
        btnLabel: 'Update',
    },
    override_future: {
        date: 'disabled',
        holiday: 'disabled',
        technician: true,
        save: true,
        delete: true,
        status: ['override_future', 'override_no_service'],
        btnLabel: 'Save Override',
    },
    override_no_service: {
        date: 'disabled',
        holiday: 'disabled',
        technician: false,
        save: true,
        delete: true,
        status: ['override_future', 'override_no_service'],
        btnLabel: 'Save Override',
    },
};
export { config };
//# sourceMappingURL=Config.js.map